import { useTranslation } from '@frontend/i18n';
import { isEmpty } from '@frontend/validation';
import { theme } from '@frontend/theme';
import { useScheduleRequestModalContext } from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/Context/ScheduleRequestModalContext';
import { getCustomFieldData } from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/utils';
import { Card } from './Card';
import { ContactItem } from './ContactItem';

export const CustomFieldsCard = () => {
  const { t } = useTranslation('scheduleCalendarRequest');
  const { selectedScheduleRequest } = useScheduleRequestModalContext();

  const customFieldData = getCustomFieldData(selectedScheduleRequest.schedulee?.insuranceInfo, ['gender']);

  // Don't render the card if there is no custom field data
  if (isEmpty(customFieldData)) return;

  return (
    <Card title={t('Custom Data')}>
      <div css={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: theme.spacing(2) }}>
        {Object.entries(customFieldData).map(([key, value]) => (
          <ContactItem key={key} label={key} value={value} />
        ))}
      </div>
    </Card>
  );
};
